import { render } from "./UIUX.vue?vue&type=template&id=580e54a7&scoped=true"
import script from "./UIUX.vue?vue&type=script&lang=js"
export * from "./UIUX.vue?vue&type=script&lang=js"

import "./UIUX.vue?vue&type=style&index=0&id=580e54a7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-580e54a7"

export default script